import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-wrap" }
const _hoisted_2 = { class: "cost-table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Artikel"),
    /*#__PURE__*/_createElementVNode("th", null, "Anzahl"),
    /*#__PURE__*/_createElementVNode("th", null, "Preis")
  ])
], -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tr", { class: "row-shipping" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Lieferkosten"),
  /*#__PURE__*/_createElementVNode("td", null, "Kostenlos")
], -1)
const _hoisted_7 = { class: "row-total" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Gesamtkosten", -1)

import { PropType, computed } from 'vue';
import { ISearchResult, ECarType, EPlateType, MonthNameMap } from '@/classes/interfaces/data';


export default /*#__PURE__*/_defineComponent({
  props: {
  License: { type: Object as PropType<ISearchResult>, required: true },
},
  setup(__props) {

const Props = __props



const ArticleName = computed((): string => {
  let Name = '';

  switch (Props.License.CarType) {
    case ECarType.PKW:
      Name += 'PKW Kennzeichen (2er Set)';
      break;
    case ECarType.Trailer:
      Name += 'Anhängerkennzeichen';
      break;
    case ECarType.MotorCycle:
      Name += 'Motorradkennzeichen';
      break;
  }
  Name += ' - <strong>' + Props.License.Code1.toUpperCase() + ' ';
  Name += Props.License.Code2.toUpperCase() + ' ';
  Name += Props.License.Code3.toUpperCase() + '</strong>';

  switch (Props.License.PlateType) {
    case EPlateType.Electric:
      Name += ' - Elektro';
      break;

    case EPlateType.OldTimer:
      Name += ' - Oldtimer';
      break;
  }

  if (
    Props.License.IsSeason &&
    Props.License.SeasonStart != null &&
    Props.License.SeasonEnd != null
  ) {
    Name += ` - ${MonthNameMap[Props.License.SeasonStart]} bis ${
      MonthNameMap[Props.License.SeasonEnd]
    }`;
  }

  return Name;
});

const ArticleCount = computed(() => {
  switch (Props.License.CarType) {
    case ECarType.PKW:
      return 1;
    case ECarType.Trailer:
      return 1;
    case ECarType.MotorCycle:
      return 1;
    default:
      return 1;
  }
});

const ArticlePrice = computed(() => {
  switch (Props.License.CarType) {
    case ECarType.PKW:
      return 30;
    case ECarType.Trailer:
      return 17.45;
    case ECarType.MotorCycle:
      return 17.45;
    default:
      return 30;
  }
});

const FormatNumber = (Input: number) => {
  return Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Input);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", { innerHTML: _unref(ArticleName) }, null, 8, _hoisted_4),
          _createElementVNode("td", {
            textContent: _toDisplayString(_unref(ArticleCount))
          }, null, 8, _hoisted_5),
          _createElementVNode("td", null, _toDisplayString(FormatNumber(_unref(ArticlePrice))), 1)
        ]),
        _hoisted_6,
        _createElementVNode("tr", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("td", null, _toDisplayString(FormatNumber(_unref(ArticlePrice) * _unref(ArticleCount))), 1)
        ])
      ])
    ])
  ]))
}
}

})